module.exports = __webpack_public_path__ + "img/logo.5d89fa4c.jpeg";